import { HOME_POINTS_OF_SALE } from '@/utils/constants/routes'

export default (ctx) => {
  return ctx.redirect(`${HOME_POINTS_OF_SALE}/bars`)
}
